import {
    AIModelCategory,
    AIModelCategoryMap,
    AIModelFramework,
    AIModelFrameworkMap,
    AIModelTask,
    AIModelTaskMap,
    AppProject,
    AppProjectType,
    AppProjectTypeMap,
    AppRegistration,
    AppRegistrationMap,
    DateFormat,
    LinkStatus,
    LinkStatusMap,
    parseTime,
} from '@common';
import { Tag } from 'antd';
import cs from 'classnames';
import _get from 'lodash/get';
import Styles from './Styles.module.scss';

export default function AppCardModal({ item }: IProps) {
    const color = item?.accessManagement.access === 'public' ? 'green' : 'purple';

    return (
        <div className={Styles.ModelCard}>
            <div className={Styles.ModelCardHeader}>
                <div className={Styles.StatusContainer}>
                    <div
                        className={cs(
                            Styles.Status,
                            { [Styles.Online]: item?.linkStatus === LinkStatus.ONLINE },
                            { [Styles.Offline]: item?.linkStatus === LinkStatus.OFFLINE },
                            { [Styles.Error]: item?.linkStatus === LinkStatus.ERROR }
                        )}
                    >
                        {item ? LinkStatusMap[item.linkStatus] : ''}
                    </div>
                    <Tag
                        className={Styles.ModelTag}
                        color={color}
                        key={item?.accessManagement.access}
                    >
                        {item?.accessManagement?.access.toUpperCase()}
                    </Tag>
                </div>
                <h2 className={Styles.ModelTitle}> {item?.title}</h2>
                <h4 className={Styles.ModelName}>{item?.name}</h4>
            </div>
            <div className={Styles.ModelCardBody}>
                <div className={Styles.ModelDetailsContainer}>
                    {columns.map(column => (
                        <div key={column.name}>
                            <strong className={Styles.LabelText}>{column.label} :</strong>{' '}
                            {column.render?.(_get(item, column.name) as never) ?? _get(item, column.name) ?? '-'}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

interface IProps {
    item: AppProject | undefined;
}

const columns = [
    {
        name: 'name',
        label: 'App Name',
    },
    {
        name: 'description',
        label: 'Description',
    },
    {
        name: 'appType',
        label: 'App Type',
        render: (value: AppProjectType) => AppProjectTypeMap[value],
    },
    {
        name: 'aiModelProperties.category',
        label: 'AI Category',
        render: (value: AIModelCategory) => AIModelCategoryMap[value],
    },
    {
        name: 'aiModelProperties.task',
        label: 'AI Task',
        render: (value: AIModelTask) => AIModelTaskMap[value],
    },
    {
        name: 'aiModelProperties.framework',
        label: 'Web Framework',
        render: (value: AIModelFramework) => AIModelFrameworkMap[value],
    },
    {
        name: 'registrationType',
        label: 'Model Type',
        render: (value: AppRegistration) => AppRegistrationMap[value],
    },
    {
        name: 'ownerName',
        label: 'Added By',
    },
    {
        name: 'updatedAt',
        label: 'Last Updated',
        render: (value: string) => parseTime(value, DateFormat.Date),
    },
    {
        name: 'createdAt',
        label: 'Added',
        render: (value: string) => parseTime(value, DateFormat.Date),
    },
];
